import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { useCallback, useState, useEffect } from 'react';

import { Submission } from 'services/types/TaskTypes';
import SubmissionItem from './SubmissionItem';
import '../TaskDetail.css';

interface Props {
  submissions: Submission[];
  mySubmission?: Submission;
}

const SubmissionList: React.FC<Props> = ({
  submissions: initialSubmissions,
  mySubmission: initialMySubmission
}) => {
  const { t } = useTranslation();
  const [submissions, setSubmissions] = useState(initialSubmissions);
  const [mySubmission, setMySubmission] = useState(initialMySubmission);

  // Update submissions when props change
  useEffect(() => {
    setSubmissions(initialSubmissions);
  }, [initialSubmissions]);

  useEffect(() => {
    setMySubmission(initialMySubmission);
  }, [initialMySubmission]);

  // Handle like update for regular submissions
  const handleSubmissionLikeUpdate = useCallback((updatedSubmission: Submission) => {
    setSubmissions(prev =>
      prev.map(submission =>
        submission.id === updatedSubmission.id ? updatedSubmission : submission
      )
    );
  }, []);

  // Handle like update for my submission
  const handleMySubmissionLikeUpdate = useCallback((updatedSubmission: Submission) => {
    setMySubmission(updatedSubmission);
  }, []);

  // Handle comment updates for regular submissions
  const handleSubmissionCommentUpdate = useCallback((submissionId: string, newComment: any) => {
    setSubmissions(prev =>
      prev.map(submission =>
        submission.id === submissionId
          ? { ...submission, comment_count: submission.comment_count + 1 }
          : submission
      )
    );
  }, []);

  // Handle comment updates for my submission
  const handleMySubmissionCommentUpdate = useCallback((submissionId: string, newComment: any) => {
    if (mySubmission && mySubmission.id === submissionId) {
      setMySubmission(prev => ({
        ...prev!,
        comment_count: prev!.comment_count + 1
      }));
    }
  }, [mySubmission]);

  return (
    <div className="submission-list-container">
      {mySubmission && (
        <div className="my-submission-section">
          <div className="my-submission-label">
            {t('#Task.my_submission')}
          </div>
          <Row gutter={[16, 16]}>
            <Col xs={24} lg={12}>
              <SubmissionItem
                item={mySubmission}
                onLikeUpdate={handleMySubmissionLikeUpdate}
                onCommentAdd={(newComment: any) => handleMySubmissionCommentUpdate(mySubmission.id, newComment)}
                isInCommentDrawer={false}
                showCommentInput={false} // Don't show comment input in list view
              />
            </Col>
          </Row>
        </div>
      )}

      <Row gutter={[16, 16]}>
        {submissions.map((item) => (
          <Col key={item.id} xs={24} lg={12}>
            <SubmissionItem
              item={item}
              onLikeUpdate={handleSubmissionLikeUpdate}
              onCommentAdd={(newComment: any) => handleSubmissionCommentUpdate(item.id, newComment)}
              isInCommentDrawer={false}
              showCommentInput={false} // Don't show comment input in list view
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default SubmissionList;